export function extractProperties(props, keys) {
    return Object.keys(props).reduce((r, k) => {
        if (keys.includes(k)) {
            r[0][k] = props[k];
        }
        else {
            r[1][k] = props[k];
        }
        return r;
    }, [{}, {}]);
}
//# sourceMappingURL=extractProperties.js.map